<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>Account Pay Requests</li>
    </ul>
  </div>
  <div class="my_supplies_listing">
    <!-- TABLE-LISTING -->
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex="100" fxFlexFill>
        <!-- tables-section -->
        <section class="table_section">
          <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <perfect-scrollbar>
              <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                <!-- Position Column -->
                <ng-container matColumnDef="sNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>S.No</th>
                  <td mat-cell *matCellDef="let element;let i = dataIndex" data-label="S.No"> {{ i+1 }} </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="supplier_name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Supplier Name</th>
                  <td mat-cell *matCellDef="let element" data-label="Supplier Name">
                    {{element?.supplier?.name}}
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                  <td mat-cell *matCellDef="let element" data-label="Name" >
                    {{element.name}}
                  </td>
                </ng-container>

                 <!-- Email Column -->
                 <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                  <td mat-cell *matCellDef="let element"  data-label="Email">
                    {{element.email}}
                  </td>
                </ng-container>

                 <!-- Phone Column -->
                 <ng-container matColumnDef="phone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
                  <td mat-cell *matCellDef="let element" data-label="Phone">
                    {{element.phone}}
                  </td>
                </ng-container>



                <ng-container matColumnDef="loading">
                  <th mat-footer-cell *matFooterCellDef colspan="8">
                    <div class="custom-loader ">
                          <div class="custom-loader custom_logo_loader">
                        <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                      </div>
                    </div>
                  </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th mat-footer-cell *matFooterCellDef colspan="8" class="no-data empty-img">
                    <img src='../../../../../../../assets/images/empty-imgs/no_account_pay.svg' alt="img" loading="lazy" />
                    <h4 class="no_state_heading">No account pay requests</h4>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
            }"></tr>
              </table>
            </perfect-scrollbar>
              <!-- TABLE-PAGINATOR -->
            <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
            fxFlexFill fxLayoutGap="8px">
              <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)"></mat-paginator>
          </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
